import { StatisticsOrder } from '@dreryk/egabinet-statistics-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Message, MessageType, NotFoundPanel } from '@dreryk/react-components';

import { PageLoader } from '../../common/PageLoader';
import { useFindStatisticsOrder } from '../useFindStatisticsOrder.hook';

type StatisticsPreviewHeaderLoaderRenderProps = {
   statisticsOrder: StatisticsOrder;
   refetchStatisticsData: VoidFunction;
};

type StatisticsPreviewHeaderLoaderProps = {
   readonly statisticsId: number;
   readonly children: (result: StatisticsPreviewHeaderLoaderRenderProps) => JSX.Element;
};

export const StatisticsPreviewHeaderLoader = (props: StatisticsPreviewHeaderLoaderProps): JSX.Element => {
   const {
      data: statisticsOrder,
      loading: statisticsOrderLoading,
      error: statisticsOrderError,
      refetch: refetchStatisticsHeaderData,
   } = useFindStatisticsOrder(props.statisticsId);

   if (statisticsOrderLoading) {
      return <PageLoader />;
   }

   if (statisticsOrderError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   if (!statisticsOrder) {
      return <NotFoundPanel />;
   }

   return props.children({
      statisticsOrder: statisticsOrder,
      refetchStatisticsData: refetchStatisticsHeaderData,
   });
};
